module.exports = __webpack_public_path__ + "img/ads-poster.13806852.jpg";